export const COUNTRY_DIAL_CODES = [
  { code: "1", label: "United States (+1)" },
  { code: "43", label: "Austria (+43)" },
  { code: "49", label: "Germany (+49)" },
  { code: "44", label: "United Kingdom (+44)" },
  { code: "33", label: "France (+33)" },
  { code: "34", label: "Spain (+34)" },
  { code: "39", label: "Italy (+39)" },
  { code: "31", label: "Netherlands (+31)" },
  { code: "41", label: "Switzerland (+41)" },
  { code: "32", label: "Belgium (+32)" },
  { code: "46", label: "Sweden (+46)" },
  { code: "47", label: "Norway (+47)" },
  { code: "45", label: "Denmark (+45)" },
  { code: "358", label: "Finland (+358)" },
  { code: "353", label: "Ireland (+353)" },
  { code: "351", label: "Portugal (+351)" },
  { code: "30", label: "Greece (+30)" },
  { code: "48", label: "Poland (+48)" },
  { code: "420", label: "Czechia (+420)" },
  { code: "421", label: "Slovakia (+421)" },
  { code: "36", label: "Hungary (+36)" },
  { code: "40", label: "Romania (+40)" },
  { code: "359", label: "Bulgaria (+359)" },
  { code: "385", label: "Croatia (+385)" },
  { code: "386", label: "Slovenia (+386)" },
  { code: "381", label: "Serbia (+381)" },
  { code: "387", label: "Bosnia and Herzegovina (+387)" },
  { code: "382", label: "Montenegro (+382)" },
  { code: "389", label: "North Macedonia (+389)" },
  { code: "90", label: "Turkey (+90)" },
  { code: "7", label: "Russia (+7)" },
  { code: "380", label: "Ukraine (+380)" },
  { code: "972", label: "Israel (+972)" },
  { code: "971", label: "United Arab Emirates (+971)" },
  { code: "966", label: "Saudi Arabia (+966)" },
  { code: "91", label: "India (+91)" },
  { code: "92", label: "Pakistan (+92)" },
  { code: "880", label: "Bangladesh (+880)" },
  { code: "94", label: "Sri Lanka (+94)" },
  { code: "977", label: "Nepal (+977)" },
  { code: "86", label: "China (+86)" },
  { code: "81", label: "Japan (+81)" },
  { code: "82", label: "South Korea (+82)" },
  { code: "65", label: "Singapore (+65)" },
  { code: "60", label: "Malaysia (+60)" },
  { code: "62", label: "Indonesia (+62)" },
  { code: "66", label: "Thailand (+66)" },
  { code: "84", label: "Vietnam (+84)" },
  { code: "63", label: "Philippines (+63)" },
  { code: "61", label: "Australia (+61)" },
  { code: "64", label: "New Zealand (+64)" },
  { code: "27", label: "South Africa (+27)" },
  { code: "20", label: "Egypt (+20)" },
  { code: "212", label: "Morocco (+212)" },
  { code: "254", label: "Kenya (+254)" },
  { code: "234", label: "Nigeria (+234)" },
  { code: "233", label: "Ghana (+233)" },
  { code: "52", label: "Mexico (+52)" },
  { code: "55", label: "Brazil (+55)" },
  { code: "54", label: "Argentina (+54)" },
  { code: "56", label: "Chile (+56)" },
  { code: "57", label: "Colombia (+57)" },
  { code: "51", label: "Peru (+51)" },
];

const DIAL_CODE_SORTED = [...COUNTRY_DIAL_CODES]
  .map((entry) => entry.code)
  .sort((a, b) => b.length - a.length);

export const DEFAULT_DIAL_CODE = "43";

export const sanitizeDigits = (value) => (value ?? "").replace(/\D/g, "");

export const parsePhoneValue = (value, fallbackDialCode = DEFAULT_DIAL_CODE) => {
  const digits = sanitizeDigits(value);
  if (!digits) {
    return { dialCode: fallbackDialCode, nationalNumber: "" };
  }

  const match = DIAL_CODE_SORTED.find((code) => digits.startsWith(code));
  if (match) {
    return { dialCode: match, nationalNumber: digits.slice(match.length) };
  }

  return { dialCode: fallbackDialCode, nationalNumber: digits };
};

export const buildPhoneValue = (dialCode, nationalNumber) => {
  const code = sanitizeDigits(dialCode);
  const number = sanitizeDigits(nationalNumber);
  if (!number) return "";
  return `+${code}${number}`;
};
